import React from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
const engineering = [{
  name: 'Doru',
  age: 43,
  role: 'CTO · scaled dev agency to 20+ people'
}, {
  name: 'Vincet',
  age: 27,
  role: '5yr tenure · Lead Builder'
}, {
  name: 'Calin',
  age: 22,
  role: 'Front-end Builder'
}, {
  name: 'Andrew',
  age: 25,
  role: 'Full Stack Builder'
}, {
  name: 'Chris',
  age: 45,
  role: 'PM'
}, {
  name: 'Savin',
  age: 43,
  role: 'DevOps Lead'
}, {
  name: 'Cornel',
  age: 35,
  role: 'Front-end Builder'
}];
const salesCs = [{
  name: 'Julita',
  age: 30,
  role: 'Account Executive'
}, {
  name: 'Michael',
  age: 31,
  role: 'Account Executive'
}, {
  name: 'Vald',
  age: 25,
  role: 'Account Executive'
}];
const growth = [{
  name: 'Smaranda',
  age: 32,
  role: 'Bought Media Expert'
}, {
  name: 'Ioana',
  age: 26,
  role: 'Design Lead'
}];
function TeamColumn({
  title,
  count,
  people
}: {
  title: string;
  count: number;
  people: {
    name: string;
    age: number;
    role: string;
  }[];
}) {
  return <div data-id="element-267">
      <div className="flex items-baseline justify-between mb-6 pb-3 border-b border-gray-800" data-id="element-268">
        <h3 className="text-xs uppercase tracking-widest text-gray-400" data-id="element-269">
          {title}
        </h3>
        <span className="font-serif text-2xl text-white" data-id="element-270">({count})</span>
      </div>
      <ul className="space-y-3" data-id="element-271">
        {people.map(p => <li key={p.name} className="flex items-baseline gap-3 text-sm" data-id="element-272">
            <span className="text-white font-medium tracking-tight whitespace-nowrap" data-id="element-273">
              {p.name}{' '}
              <span className="text-gray-500 font-normal" data-id="element-274">({p.age})</span>
            </span>
            <span className="text-gray-400 leading-snug" data-id="element-275">— {p.role}</span>
          </li>)}
      </ul>
    </div>;
}
export function SlideTeam() {
  return <Slide data-id="element-276">
      <SlideHeader data-id="element-277">Team</SlideHeader>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-278">
        {/* Alex — Founder & CEO */}
        <motion.div variants={itemVariants} className="lg:col-span-4 flex flex-col" data-id="element-279">
          <div className="w-40 h-40 md:w-48 md:h-48 rounded-full overflow-hidden mb-8 border border-gray-800 bg-gray-900 relative grayscale" data-id="element-280">
            <img src="https://cdn.magicpatterns.com/uploads/iBheJLGYwgU7tbFkj9atYU/pasted-image.png" alt="Alex Circei" className="absolute inset-0 w-full h-full object-cover" data-id="element-281" />
          </div>

          <h2 className="text-4xl md:text-5xl font-serif tracking-tight leading-[1.05] mb-2" data-id="element-282">
            Alex Circei
          </h2>
          <div className="text-sm text-gray-400 uppercase tracking-widest mb-8" data-id="element-283">
            Founder & CEO
          </div>

          <div className="space-y-3 mb-8" data-id="element-284">
            <div className="flex items-center gap-3" data-id="element-285">
              <span className="font-serif text-3xl text-white leading-none" data-id="element-286">
                3
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-widest" data-id="element-287">
                Exits
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-288">
              <span className="font-serif text-3xl text-white leading-none" data-id="element-289">
                YC
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-widest" data-id="element-290">
                W21
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-291">
              <span className="font-serif text-3xl text-white leading-none" data-id="element-292">
                1
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-widest" data-id="element-293">
                Git Analytics Patent
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-294">
              <span className="font-serif text-3xl text-white leading-none" data-id="element-295">
                $20M+
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-widest" data-id="element-296">
                Software Sales Generated
              </span>
            </div>
          </div>
        </motion.div>

        {/* Team breakdown */}
        <motion.div variants={itemVariants} className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8" data-id="element-297">
          <div className="md:col-span-2" data-id="element-298">
            <TeamColumn title="Engineering" count={engineering.length} people={engineering} data-id="element-299" />
          </div>
          <div className="space-y-10" data-id="element-300">
            <TeamColumn title="Sales & CS" count={salesCs.length} people={salesCs} data-id="element-301" />
            <TeamColumn title="Growth" count={growth.length} people={growth} data-id="element-302" />
          </div>
        </motion.div>
      </div>

      <motion.div variants={itemVariants} className="pt-8 mt-8 border-t border-gray-800 flex justify-between items-baseline text-xs uppercase tracking-widest text-gray-500" data-id="element-303">
        <span data-id="element-304">13 builders · 1 mission</span>
        <span className="text-white" data-id="element-305">The brain behind the brain.</span>
      </motion.div>
    </Slide>;
}